import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import "jquery-libs/jquery.signaturepad";

ko.bindingHandlers.sigpad = {
    'init':function(element, valueAccessor, allBindingsAccessor, viewModel) {
        var field = ko.utils.unwrapObservable(valueAccessor());
        var readonly = $(element).data("readonly") == "readonly";
        var $canvas = $(element).find("canvas");
        if(readonly)
        {
            try {
                $(element).signaturePad({"displayOnly":true}).regenerate(field);
            }
            catch(e) {
                console.log(e);
            }
        }
        else 
        { 
            try {
                $(element).signaturePad({
                    "defaultAction":"drawIt", 
                    "onDrawEnd":function() {
                        setTimeout(function() {
                            $(element).parent().find("input.output").change();
                        }, 0);
                    }
                }).regenerate(field);
                setTimeout(function() {
                    $canvas.prop("width", $canvas.width());
                    $canvas.prop("height", $canvas.height());
                    $(element).signaturePad("clearCanvas");
                }, 200);
                    
                
            }
            catch(e) {
                console.log(e);
                
            }
        }
    },
    "update":function(element, valueAccessor, allBindingsAccessor, viewModel) {
        
    }
};
